module.exports = __webpack_public_path__ + "img/paternoster-07.61e8fad3.jpg";